import React, { ReactNode } from 'react';
import { Modal } from 'react-bootstrap';

interface propsModalProgress {
    children: ReactNode;
    showModalProgress: boolean
    setShowModalProgress: React.Dispatch<React.SetStateAction<boolean>>
}

export function ModalProgress(props: propsModalProgress) {
    return (
        <Modal
            show={props.showModalProgress}
            onHide={() => props.setShowModalProgress(false)}
            dialogClassName="modal-info-progress"
            animation={true}
            centered={true}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body>
                {props.children}
            </Modal.Body>
        </Modal>
    );
}